/**
 * Converts an attribute value to something displayable.
 *
 * Attribute values arrive as `unknown` because their type is decided by the
 * species definition, not by TypeScript. Passing an object to String() would
 * silently render "[object Object]", so unexpected shapes become an empty
 * field instead — visibly wrong rather than deceptively present.
 */
export function toFieldValue(value: unknown): string {
  if (value === null || value === undefined) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'number' || typeof value === 'bigint') return String(value)
  if (typeof value === 'boolean') return value ? 'true' : 'false'
  if (value instanceof Date) return value.toISOString().slice(0, 10)

  return ''
}

/** Reads a text field out of a FormData, which may also yield a File. */
export function formString(data: FormData, key: string): string {
  const value = data.get(key)

  return typeof value === 'string' ? value : ''
}
